import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import AssociationSummary from "./AssociationSummary";
import AssociationMembers from "./AssociationMember";
import "bootstrap/dist/css/bootstrap.min.css";

function Associationtab() {
  return (
    <>
      <Tabs
        defaultActiveKey="AssociationMembers"
        id="uncontrolled-tab-example"
        className="mb-3"
      >
        <Tab eventKey="AssociationMembers" title="สมาชิกทั้งหมด">
          <AssociationMembers />
        </Tab>
        <Tab eventKey="AssociationSummary" title="ข้อมูลรายสมาคม">
          <AssociationSummary />
        </Tab>
      </Tabs>
    </>
  );
}

export default Associationtab;
